/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.insights.rpc.UserInsightsChirpService
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './UserInsightsChirpService';
import * as Queries from './UserInsightsChirpService.dfc.new';
import type { AdditionalContextArgs } from './UserInsightsChirpService.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetUserInsightsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetUserInsightsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getUserInsights', References.GetUserInsightsResponseType>
        : References.GetUserInsightsResponseType)
    | undefined;
};

export function useGetUserInsightsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetUserInsightsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserInsightsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_USER_INSIGHTS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserInsights: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserInsightsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetUserInsightsQueryReturn<T>;
}

type UseGetUserInsightsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetUserInsightsResponseType>,
    {},
    T extends true
      ? Record<'getUserInsights', References.GetUserInsightsResponseType>
      : References.GetUserInsightsResponseType
  >;

export function useGetUserInsightsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetUserInsightsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserInsightsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_USER_INSIGHTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserInsights: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetUserInsightsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetUserInsightsLazyQueryReturn<T>;
}

type UseGetUserInsightsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetUserInsightsResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getUserInsights', References.GetUserInsightsResponseType>
    : References.GetUserInsightsResponseType;
};

export function useGetUserInsightsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetUserInsightsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserInsightsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_USER_INSIGHTS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getUserInsights: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserInsightsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetUserInsightsSuspenseQueryReturn<T>;
}
